import React, { useState, useEffect } from 'react';

const ScrollArrow = (props) => {
  const [showScroll, setShowScroll] = useState(false);
  const modalELs = document.getElementsByClassName('modal');
  const modalEL = modalELs[props.scrollCount - 1];

  const scrollTop = () => {
    if (window.document.documentMode) {
      // specify for IE only ...
      modalEL.scrollTop = 0;
    } else {
      modalEL.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (props.scrollCount > 0) {
      const checkScrollTop = () => {
        if (modalEL.scrollTop > props.totopPixel) {
          setShowScroll(true);
        } else if (modalEL.scrollTop <= props.totopPixel) {
          setShowScroll(false);
        }
      };
      if (modalEL) {
        modalEL.addEventListener('scroll', checkScrollTop);
      }
    }
  }, [modalEL, props.scrollCount, props.totopPixel]);

  return (
    <div className="scrollTop" onClick={scrollTop} style={{ display: showScroll ? 'flex' : 'none' }} title='Back To Top'>
      <i className="uparrow"></i>
    </div >
  );
}

export default ScrollArrow;